import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-commercial",
  "use": "icon-commercial-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-commercial\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M14.91,9.53l.93.92-4.17,4.17L8.9,11.84l.92-.92,1.85,1.85,3.24-3.24ZM12,6.14l-4.58,1v6a2.61,2.61,0,0,0,1.16,2.18L12,17.63l3.42-2.28a2.61,2.61,0,0,0,1.16-2.18v-6L12,6.14ZM12,4.8,17.38,6a.66.66,0,0,1,.51.64v6.54a3.92,3.92,0,0,1-1.75,3.27L12,19.2,7.86,16.44a3.92,3.92,0,0,1-1.75-3.27V6.63A.66.66,0,0,1,6.62,6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol